// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header .toolbar {
  min-height: 70px;
}
ion-header .toolbar ion-img {
  width: 180px;
}
ion-header .toolbar .right-block {
  display: flex;
  justify-content: center;
  align-items: center;
}
ion-header .categories-block {
  height: 75px;
  background-color: transparent;
  display: flex;
  align-self: center;
  justify-content: space-around;
}
ion-header .categories-block .chip-scroll {
  width: 40px;
}
ion-header .categories-block .category-list {
  transition: 1s linear;
  opacity: 1;
  display: flex;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
  width: calc(100% - 10px);
  align-items: center;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list > ion-chip {
    overflow: unset;
    display: flex;
  }
}
ion-header .categories-block .category-list::-webkit-scrollbar {
  display: none;
}
ion-header .categories-block .category-list .line-dotted-block:last-child {
  display: none;
}
ion-header .categories-block .category-list .category-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 60px;
  min-width: -moz-fit-content;
  min-width: fit-content;
  position: relative;
}
ion-header .categories-block .category-list .category-wrapper .category-name {
  font-size: 18px;
  color: #fff;
  text-align: center;
  margin: 0px 10px;
  position: relative;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  font-family: var(--font-tusker);
  padding: 20px;
  height: 60px;
}
ion-header .categories-block .category-list .category-wrapper .top_icon {
  position: absolute;
  width: 100%;
}
ion-header .categories-block .category-list .category-wrapper:first-child {
  margin-left: 12px;
}
ion-header .categories-block .category-list .category-wrapper:last-child {
  margin-right: 12px;
}
ion-header .categories-block .category-list .category-wrapper.selected .category-name::before {
  content: "";
  position: absolute;
  bottom: -6px;
  height: 3px;
  width: 100%;
  background-color: var(--ion-color-tertiary);
  transition: width 0.2s linear;
}
ion-header .categories-block .category-list .category-wrapper ion-chip {
  opacity: 0.4;
  border-radius: 50%;
  padding: 5px;
  background: white;
  transition: color 200ms linear, background 200ms linear;
  text-transform: capitalize;
  flex: 0 0 auto;
  height: 30px;
  width: 60px;
  margin: 0px;
  padding: 0px;
  position: relative;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list .category-wrapper ion-chip {
    height: 110px;
    width: 110px;
  }
}
ion-header .categories-block .category-list .category-wrapper ion-chip .category-image {
  width: 100%;
}
ion-header .categories-block .category-list .category-wrapper ion-chip .border-dotted {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 58px;
  height: 58px;
}
@media (min-width: 991px) {
  ion-header .categories-block .category-list .category-wrapper ion-chip .border-dotted {
    height: 107px;
    width: 107px;
  }
}

.item-responsive {
  width: 100%;
}
@media (min-width: 991px) {
  .item-responsive {
    width: calc(25% - 10px);
    margin: 0 5px 10px;
  }
}

.articles-wrapper {
  padding: 18px 12px 0;
  position: relative;
}
@media (min-width: 991px) {
  .articles-wrapper {
    margin: 0 -5px;
  }
}

ion-searchbar {
  height: 34px;
  padding-inline-end: 12px;
  padding-inline-start: 12px;
  --placeholder-color: var(--ion-color-secondary);
  --placeholder-opacity: 1;
  --color: var(--ion-color-secondary);
  --icon-color: var(--ion-color-secondary);
  --border-radius: 0px;
  border-radius: 10px;
  font-size: 14px;
  font-family: AppFont, sans-serif;
}
@media (min-width: 991px) {
  ion-searchbar {
    width: auto;
  }
}

.main-row {
  height: 100%;
  overflow: hidden;
}
@media (max-width: 992px) {
  .main-row {
    padding-top: 25px;
  }
}
.main-row.hidden {
  visibility: hidden;
  min-height: 0px;
  height: 0px;
  transition: ease-out 1s;
}

app-order-content {
  display: block;
  height: 100%;
}

.order-col {
  min-width: 380px;
}

.padding-end {
  padding-right: 11px;
}

ion-footer {
  background-color: var(--ion-color-tertiary);
  border-radius: 50px;
  text-transform: uppercase;
  display: flex;
}

.footer-btn {
  width: 100%;
}
@media (min-width: 991px) {
  .footer-btn {
    display: none;
  }
}
.footer-btn app-to-order-button {
  width: 100%;
}

.hidden {
  opacity: 0;
  display: none !important;
  transition: 1s linear !important;
}

.chip {
  background: transparent;
  transition: 200ms linear;
  min-width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}
@media (min-width: 991px) {
  .chip {
    display: none !important;
  }
}
.chip .chip-icon {
  margin: 0;
  height: 16px;
}

.chip-scroll {
  background: transparent;
  transition: 200ms linear;
  min-width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}
.chip-scroll.rotate {
  transform: rotate(180deg) !important;
}
.chip-scroll .chip-icon {
  transform: rotate(180deg);
  margin: 0;
  height: 36px;
}

.category-info {
  max-height: 70px;
}
@media (min-width: 991px) {
  .category-info {
    max-height: 80px;
  }
  .category-info ion-img {
    height: 80px;
  }
}
.category-info ion-img {
  height: 70px;
  width: 100%;
  object-fit: cover;
}

.background-image {
  width: 100%;
  height: 30px;
  position: absolute;
  left: 0px;
  top: 0px;
  background: url('test.svg') center top/100% no-repeat !important;
  z-index: 99;
}
@media (min-width: 991px) {
  .background-image {
    height: 45px;
    background: url('test_desktop.svg') center top/103% no-repeat !important;
  }
}

ion-content {
  --offset-top: 4px !important;
}
@media (min-width: 991px) {
  ion-content {
    --offset-top: 23px !important;
  }
}

.category-block {
  max-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 10px;
  width: -moz-fit-content;
  width: fit-content;
  position: relative;
  transition: all 1.2s;
  cursor: pointer;
}
.category-block h4 {
  font-size: 14px;
  text-wrap: nowrap;
  z-index: 999999;
  color: white;
  padding: 0px 10px;
  width: max-content;
}
.category-block ion-img {
  position: absolute;
  left: 0;
  right: 0;
  object-fit: fill;
  height: 40px;
  z-index: 1;
}

.category-wrapper {
  background: url('category-background.png') no-repeat center center/110% 138%;
  background-size: cover;
  transition: all 0.5s;
  background-size: 1100px;
}
@media (min-width: 991px) {
  .category-wrapper {
    background-size: 4000px;
  }
}
.category-wrapper.vegan_selected {
  transition: all 0.5s;
  background: #06331B url('category-background.png') no-repeat center center/110% 168%;
  background-size: cover;
  background-size: 1100px;
}
@media (min-width: 991px) {
  .category-wrapper.vegan_selected {
    background-size: 4000px;
  }
}
@media (min-width: 991px) {
  .category-wrapper.vegan_selected {
    background: #06331B;
  }
}

.wrapper-filters {
  min-height: 70px;
  width: 100%;
  transition: all 0.3s;
}
.wrapper-filters.hidden {
  visibility: hidden;
  opacity: 0;
  width: 0px;
  transition: all 0.2s;
}
.wrapper-filters.vegan_green {
  transition: all 0.3s;
  background: #06331B;
}
.wrapper-filters ion-row {
  height: 100%;
}
.wrapper-filters ion-row .header_block_item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
}
.wrapper-filters ion-row .header_block_item ion-icon {
  width: 23px;
  margin-right: 5px;
  fill: white;
}
.wrapper-filters ion-row .header_block_item h3 {
  font-size: 18px;
  color: white;
  font-family: AppFont, sans-serif;
}
.wrapper-filters ion-row .header_block_item::after {
  position: absolute;
  right: 0px;
  content: " ";
  width: 2px;
  height: 30px;
  background: white;
}
.wrapper-filters ion-row .vegan_toggle {
  display: flex;
  justify-content: center;
}

.toggler {
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border: 2px solid var(--ion-color-primary);
  box-shadow: inset -2px 2px 10px rgba(0, 0, 0, 0.25);
  padding: 7px;
  border-radius: 50px;
  width: 100px;
  position: relative;
}
.toggler.vegeterian {
  background: white;
  border: 2px solid #34A853;
}
.toggler .toggler_item {
  padding: 0 7px;
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 19px;
  color: #06331B;
  height: 20px;
  transition: all 0.4s;
}
.toggler .toggler_item.selected {
  opacity: 0;
  width: 44%;
  overflow: hidden;
}
.toggler .toggler_pin {
  position: absolute;
  color: red;
  top: -14px;
  cursor: pointer;
  transition: all 0.3s ease-out;
}
.toggler .toggler_pin .pin_img {
  height: 65px;
  width: 65px;
}
.toggler .toggler_pin.first {
  left: -13px;
}
.toggler .toggler_pin.second {
  left: 61px;
}
@media (max-width: 992px) {
  .toggler .toggler_pin.second {
    left: 44px;
  }
}

.row-filters {
  visibility: visible;
  opacity: 1;
  transition: all 0.5s;
}
.row-filters.hidden {
  visibility: hidden;
  opacity: 0;
  transition: all 0.5s;
}

.search-row {
  visibility: hidden;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.5s;
}
.search-row.visible {
  visibility: visible;
  opacity: 1;
  transition: all 0.5s;
}

.filters-dialog {
  background: var(--ion-color-secondary);
  z-index: 0;
  visibility: hidden;
  opacity: 0;
  min-height: 0px;
  height: 0px;
  transition: ease-in-out 0.5s;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 0;
  overflow: hidden !important;
  text-align: center;
}
.filters-dialog .filters-button {
  position: fixed;
  bottom: 20px;
  width: 48.4% !important;
  left: 50%;
  transform: translateX(-50%);
}
@media (max-width: 992px) {
  .filters-dialog .filters-button {
    width: 86% !important;
  }
}
@media (max-width: 380px) {
  .filters-dialog .filters-button {
    bottom: 6px;
  }
}
.filters-dialog .filters-button ion-button {
  width: 100%;
}
@media (min-width: 991px) {
  .filters-dialog .filters-button ion-button {
    --background: url('button_background_orange.png') no-repeat center center/ 100% 100%;
  }
}
.filters-dialog__header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filters-dialog__header h3 {
  color: white;
}
.filters-dialog__border-line {
  width: 100%;
  margin: 10px 0px;
  fill: white;
}
.filters-dialog__content {
  width: 100%;
  visibility: hidden;
}
.filters-dialog__content p {
  color: white;
  font-family: Tusker, sans-serif;
}
.filters-dialog__content.visible_content {
  visibility: visible;
  transition: ease-out 0.5s;
}
.filters-dialog.visible {
  padding: 20px;
  width: 100%;
  min-height: 100%;
  height: 100%;
  opacity: 1;
  z-index: 999;
  visibility: visible;
  transition: all 0.5s;
  overflow: auto;
}
.filters-dialog ul {
  list-style-type: none;
  padding: 0px;
  width: 0px;
  visibility: hidden;
  height: 0px;
  opacity: 0;
}
.filters-dialog ul.visible_content {
  opacity: 1;
  width: 100%;
  height: 100%;
  visibility: visible;
  transition: all 0.7s;
}
.filters-dialog ul li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0px;
  text-decoration: none;
  transition: all 1s;
}
.filters-dialog ul li .wrapper {
  padding: 20px 20px;
  background: white;
  width: 100%;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.filters-dialog ul li .wrapper .info_block {
  border-radius: 20px;
  display: flex;
  align-items: center;
}
.filters-dialog ul li .wrapper .info_block p {
  padding: 0px 10px;
  color: var(--ion-color-primary);
  font-family: Tusker, sans-serif;
}
.filters-dialog ul li .wrapper .circle {
  width: 0px;
  height: 20px;
  content: " ";
  border: 2px solid var(--ion-color-primary);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  visibility: hidden;
  opacity: 0;
  transition: ease-out 0.3s;
}
.filters-dialog ul li .wrapper .circle.selected {
  visibility: visible;
  opacity: 1;
  width: 20px;
}
.filters-dialog ul li .wrapper .cirle_inner {
  width: 0px;
  height: 20px;
  content: " ";
  background: transparent;
  border-radius: 5px;
  margin-bottom: 5px;
  position: relative;
}
.filters-dialog ul li .wrapper .cirle_inner.selected {
  width: 20px;
  background: var(--ion-color-tertiary);
  border-radius: 50;
  transition: ease-in-out 0.3s;
}
.filters-dialog ul li .wrapper .cirle_inner ion-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0px;
  transform: translate(-50%, -50%);
  color: white;
}
.filters-dialog ul li .wrapper .cirle_inner ion-icon.selected {
  width: 20px;
}

.order-button {
  background: transparent !important;
}
@media (min-width: 991px) {
  .order-button {
    display: none;
  }
}

.hidden_item {
  visibility: hidden;
  opacity: 0;
  width: 0;
  display: none;
}
.hidden_item.visible {
  width: 100%;
  visibility: visible;
  opacity: 1;
}

.no-data {
  height: 70vh;
  position: relative;
  width: 100%;
}
.no-data h3 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: Tusker, sans-serif;
}

.big-screen {
  display: none;
}
@media (min-width: 991px) {
  .big-screen {
    display: block;
  }
  .big-screen.wrapper-filters {
    padding-top: 10px;
    height: 100%;
  }
  .big-screen.wrapper-filters .separator {
    width: 1.5px;
    height: 30px;
    background: var(--ion-color-primary);
  }
  .big-screen.wrapper-filters .header_block_item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
  }
  .big-screen.wrapper-filters .header_block_item.vegan_color ion-icon {
    fill: white !important;
    color: white !important;
  }
  .big-screen.wrapper-filters .header_block_item.vegan_color h3 {
    color: white !important;
  }
  .big-screen.wrapper-filters .header_block_item ion-icon {
    width: 23px;
    margin-right: 5px;
    fill: var(--ion-color-primary) !important;
    color: var(--ion-color-primary) !important;
  }
  .big-screen.wrapper-filters .header_block_item h3 {
    font-size: 18px;
    color: var(--ion-color-primary) !important;
    font-family: AppFont, sans-serif;
  }
  .big-screen.wrapper-filters .search-row {
    height: 0px;
    max-height: 0px;
    padding-top: 10px;
  }
}

.small-screen {
  display: none;
}
@media (max-width: 992px) {
  .small-screen {
    display: block;
  }
}

.category-header {
  font-family: Tusker;
  font-size: 24px;
  text-align: left;
  position: relative;
  background: url('button_background_primary.png') no-repeat center center/100% 100%;
  display: flex;
  align-items: center;
  padding: 10px;
  margin: 10px;
}
.category-header h3 {
  z-index: 99;
  padding: 10px;
  color: white;
}

.dialog_auto {
  overflow: auto;
  max-height: -moz-fit-content;
  max-height: fit-content;
  min-height: 88%;
}
@media (max-width: 400px) {
  .dialog_auto {
    padding-bottom: 60px;
    min-height: 85%;
    max-height: 50%;
  }
}
@media (min-width: 991px) {
  .dialog_auto {
    display: flex;
    justify-content: center;
  }
  .dialog_auto .dialog_item {
    width: 50%;
  }
}

.reset {
  background-size: 97% 97%;
  padding: 4px 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 6px;
}
.reset ion-icon {
  margin-right: 10px;
  height: 10px;
  width: 35px;
  height: 35px;
}
.reset ion-img {
  margin-right: 5px;
  height: 10px;
  width: 14px;
  height: 14px;
}
.reset p {
  color: var(--ion-color-black);
  font-family: AppFontBold;
  text-transform: capitalize;
}

.list-articles {
  width: 100%;
  height: 100%;
  transition: 1s linear;
  opacity: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
  align-items: center;
  justify-content: flex-start;
}

.items-wrap {
  width: 100%;
}

.content-articles {
  position: relative;
  width: 100%;
  height: 100%;
}

.info_dialog_error {
  background: var(--ion-color-primary);
  padding: 8px 17px;
  text-align: center;
  width: max-content;
  animation: appears 0.3s forwards;
  height: -moz-fit-content;
  height: fit-content;
  margin: 0 auto 30px;
  max-width: 80%;
}
.info_dialog_error p {
  height: -moz-fit-content;
  height: fit-content;
  max-height: max-content;
  color: white;
}
@keyframes appears {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.wrapper-errors {
  position: relative;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGE;EACE,gBAAA;AAFJ;AAGI;EACE,YAAA;AADN;AAGI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AADN;AAKE;EACE,YAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;AAHJ;AAKI;EACE,WAAA;AAHN;AAKI;EACE,qBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,YAAA;EACA,wBAAA;EACA,mBAAA;AAHN;AC9BE;EDoCM;IACE,eAAA;IACA,aAAA;EAHR;AACF;AAOM;EACE,aAAA;AALR;AAOM;EACE,aAAA;AALR;AAQM;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EAAA,sBAAA;EAEA,kBAAA;AAPR;AAQQ;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+BAAA;EAEA,aAAA;EACA,YAAA;AAPV;AAUQ;EACE,kBAAA;EACA,WAAA;AARV;AAUQ;EACE,iBAAA;AARV;AAWQ;EACE,kBAAA;AATV;AAYU;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,2CAAA;EACA,6BAAA;AAVZ;AAcQ;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,uDAAA;EACA,0BAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAZV;AC/FE;ED+FM;IAcI,aAAA;IACA,YAAA;EAVV;AACF;AAWU;EACE,WAAA;AATZ;AAWU;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;AATZ;AChHE;EDmHQ;IAQI,aAAA;IACA,YAAA;EAPZ;AACF;;AAeA;EACE,WAAA;AAZF;AC1HE;EDqIF;IAGI,uBAAA;IACA,kBAAA;EAVF;AACF;;AAaA;EACE,oBAAA;EACA,kBAAA;AAVF;ACrIE;ED6IF;IAII,cAAA;EARF;AACF;;AAWA;EACE,YAAA;EACA,wBAAA;EACA,0BAAA;EACA,+CAAA;EACA,wBAAA;EACA,mCAAA;EACA,wCAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AARF;ACxJE;EDqJF;IAcI,WAAA;EAPF;AACF;;AAUA;EACE,YAAA;EACA,gBAAA;AAPF;AC5JE;EDiKF;IAII,iBAAA;EALF;AACF;AAOE;EACE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;AALJ;;AASA;EACE,cAAA;EACA,YAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AAQA;EACE,2CAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;AALF;;AASA;EACE,WAAA;AANF;ACrME;ED0MF;IAGI,aAAA;EAJF;AACF;AAKE;EACE,WAAA;AAHJ;;AAOA;EACE,UAAA;EACA,wBAAA;EACA,gCAAA;AAJF;;AAOA;EACE,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAJF;AC7NE;ED0NF;IASI,wBAAA;EAFF;AACF;AAGE;EACE,SAAA;EACA,YAAA;AADJ;;AAIA;EACE,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AADF;AAEE;EACE,oCAAA;AAAJ;AAEE;EACE,yBAAA;EACA,SAAA;EACA,YAAA;AAAJ;;AAIA;EACE,gBAAA;AADF;AC5PE;ED4PF;IAGI,gBAAA;EACF;EAAE;IACE,YAAA;EAEJ;AACF;AAAE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAEJ;;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gEAAA;EAKA,WAAA;AAFF;ACnRE;ED0QF;IAQI,YAAA;IACA,wEAAA;EAKF;AACF;;AAFA;EACE,4BAAA;AAKF;AC7RE;EDuRF;IAGI,6BAAA;EAOF;AACF;;AALA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;AAQF;AANE;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAQJ;AALE;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;AAOJ;;AAHA;EACE,4EAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;AAMF;ACtUE;ED4TF;IAMI,uBAAA;EAQF;AACF;AAPE;EACE,oBAAA;EACA,oFAAA;EACA,sBAAA;EACA,uBAAA;AASJ;ACjVE;EDoUA;IAMI,uBAAA;EAWJ;AACF;ACtVE;EDoUA;IAWI,mBAAA;EAWJ;AACF;;AARA;EACE,gBAAA;EACA,WAAA;EACA,oBAAA;AAWF;AAVE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EAEA,oBAAA;AAWJ;AATE;EACE,oBAAA;EAEA,mBAAA;AAUJ;AARE;EACE,YAAA;AAUJ;AATI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAWN;AAVM;EACE,WAAA;EACA,iBAAA;EACA,WAAA;AAYR;AAVM;EACE,eAAA;EACA,YAAA;EACA,gCAAA;AAYR;AARI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;AAUN;AARI;EACE,aAAA;EACA,uBAAA;AAUN;;AALA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,iBAAA;EACA,0CAAA;EACA,mDAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EAEA,kBAAA;AAMF;AAJE;EACE,iBAAA;EACA,yBAAA;AAMJ;AAFE;EACE,cAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;AAIJ;AAFI;EACE,UAAA;EACA,UAAA;EACA,gBAAA;AAIN;AAAE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,6BAAA;AAEJ;AAAI;EACE,YAAA;EACA,WAAA;AAEN;AACI;EACE,WAAA;AACN;AAEI;EACE,UAAA;AAAN;ACrbE;EDobE;IAGI,UAAA;EAEN;AACF;;AAEA;EACE,mBAAA;EACA,UAAA;EACA,oBAAA;AACF;AACE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;AACJ;;AAGA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AAAF;AACE;EACE,mBAAA;EACA,UAAA;EACA,oBAAA;AACJ;;AAGA;EACE,sCAAA;EACA,UAAA;EAEA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,QAAA;EACA,2BAAA;EACA,kBAAA;AAFF;AAGE;EACE,eAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,2BAAA;AADJ;AC1eE;EDseA;IAOI,qBAAA;EACJ;AACF;AACI;EAVF;IAWI,WAAA;EAEJ;AACF;AADI;EACE,WAAA;AAGN;AC7fE;EDyfE;IAGI,oFAAA;EAKN;AACF;AADE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAGJ;AAFI;EACE,YAAA;AAIN;AADE;EACE,WAAA;EACA,gBAAA;EACA,WAAA;AAGJ;AADE;EACE,WAAA;EACA,kBAAA;AAGJ;AAFI;EACE,YAAA;EACA,+BAAA;AAIN;AAFI;EACE,mBAAA;EACA,yBAAA;AAIN;AADE;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;AAGJ;AAAE;EACE,qBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AAEJ;AADI;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;AAGN;AAAK;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AAEN;AADM;EACI,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAGV;AAFU;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;AAId;AAHc;EACI,iBAAA;EACA,+BAAA;EACA,+BAAA;AAKlB;AAFU;EACI,UAAA;EACA,YAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EAMA,yBAAA;AADd;AAJc;EACE,mBAAA;EACA,UAAA;EACA,WAAA;AAMhB;AADU;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAGZ;AADY;EACE,WAAA;EACE,qCAAA;EACA,iBAAA;EACA,4BAAA;AAGhB;AADY;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;EACA,YAAA;AAGd;AAFc;EACE,WAAA;AAIhB;;AAKA;EACE,kCAAA;AAFF;ACloBE;EDmoBF;IAGI,aAAA;EAAF;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,aAAA;AACF;AAAE;EACE,WAAA;EACA,mBAAA;EACA,UAAA;AAEJ;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;AACF;AAAE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,+BAAA;AAEJ;;AACA;EACE,aAAA;AAEF;ACpqBE;EDiqBF;IAGI,cAAA;EAIF;EAHE;IAEE,iBAAA;IACE,YAAA;EAIN;EAHM;IACE,YAAA;IACA,YAAA;IACA,oCAAA;EAKR;EAHM;IACE,kBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,WAAA;IACA,kBAAA;EAKR;EAHU;IACE,sBAAA;IACA,uBAAA;EAKZ;EAHU;IACE,uBAAA;EAKZ;EAFQ;IACE,WAAA;IACA,iBAAA;IACA,yCAAA;IACA,0CAAA;EAIV;EADQ;IACE,eAAA;IACA,0CAAA;IACA,gCAAA;EAGV;EAEM;IACE,WAAA;IACA,eAAA;IACA,iBAAA;EAAR;AACF;;AAMA;EACE,aAAA;AAHF;AC/sBE;EDitBF;IAGI,cAAA;EADF;AACF;;AAGA;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kFAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AAAF;AACE;EACE,WAAA;EACA,aAAA;EACA,YAAA;AACJ;;AAEA;EACE,cAAA;EACA,4BAAA;EAAA,uBAAA;EACA,eAAA;AACF;AACE;EALF;IAMI,oBAAA;IACA,eAAA;IAEA,eAAA;EACF;AACF;ACxvBE;ED6uBF;IAYI,aAAA;IACA,uBAAA;EAGF;EAFE;IACE,UAAA;EAIJ;AACF;;AACA;EAEE,wBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AACJ;AACE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AACJ;AACE;EACE,6BAAA;EACA,wBAAA;EACA,0BAAA;AACJ;;AAGA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,qBAAA,EAAA,YAAA;EAEA,mBAAA;EACA,2BAAA;AADF;;AAGA;EACE,WAAA;AAAF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EAEE,oCAAA;EAEA,iBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,gCAAA;EACA,wBAAA;EAAA,mBAAA;EACA,mBAAA;EACA,cAAA;AAFF;AAGE;EACE,wBAAA;EAAA,mBAAA;EACA,uBAAA;EACA,YAAA;AADJ;AAGE;EACE;IACE,UAAA;EADJ;EAGE;IACE,UAAA;EADJ;AACF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;AADF","sourcesContent":["@import \"../../../theme/mixins\";\n\nion-header {\n  .toolbar {\n    min-height: 70px;\n    ion-img {\n      width: 180px;\n    }\n    .right-block {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  .categories-block {\n    height: 75px;\n    background-color: transparent;\n    display: flex;\n    align-self: center;\n    justify-content: space-around;\n\n    .chip-scroll {\n      width: 40px;\n    }\n    .category-list {\n      transition: 1s linear;\n      opacity: 1;\n      display: flex;\n      overflow: auto;\n      scroll-behavior: smooth;\n      -ms-overflow-style: none;\n      scrollbar-width: none; /* Firefox */\n      width: calc(100% - 10px);\n      align-items: center;\n\n      @include desktop {\n        > ion-chip {\n          overflow: unset;\n          display: flex;\n          // flex-grow: 1 !important;\n        }\n      }\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n      .line-dotted-block:last-child {\n        display: none;\n      }\n\n      .category-wrapper {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        height: 60px;\n        min-width: fit-content;\n     \n        position: relative;\n        .category-name {\n          font-size: 18px;\n          color: #fff;\n          text-align: center;\n          margin: 0px 10px;\n          position: relative;\n          cursor: pointer;\n          width: fit-content;\n          font-family: var(--font-tusker);\n          // background: url('../../../assets/tabilo/background-category.svg') center/100% 100% no-repeat;\n          padding: 20px;\n          height: 60px;\n \n        }\n        .top_icon {\n          position: absolute;\n          width: 100%;\n        }\n        &:first-child {\n          margin-left: 12px;\n        }\n\n        &:last-child {\n          margin-right: 12px;\n        }\n        &.selected {\n          .category-name::before {\n            content: \"\";\n            position: absolute;\n            bottom: -6px;\n            height: 3px;\n            width: 100%;\n            background-color: var(--ion-color-tertiary);\n            transition: width 0.2s linear;\n          }\n        }\n\n        ion-chip {\n          opacity: 0.4;\n          border-radius: 50%;\n          padding: 5px;\n          background: white;\n          transition: color 200ms linear, background 200ms linear;\n          text-transform: capitalize;\n          flex: 0 0 auto;\n          height: 30px;\n          width: 60px;\n          margin: 0px;\n          padding: 0px;\n          position: relative;\n          @include desktop {\n            height: 110px;\n            width: 110px;\n          }\n          .category-image {\n            width: 100%;\n          }\n          .border-dotted {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n            width: 58px;\n            height: 58px;\n            @include desktop {\n              height: 107px;\n              width: 107px;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.item-responsive {\n  width: 100%;\n  @include desktop {\n    width: calc(25% - 10px);\n    margin: 0 5px 10px;\n  }\n}\n\n.articles-wrapper {\n  padding: 18px 12px 0;\n  position: relative;\n  @include desktop {\n    margin: 0 -5px;\n  }\n}\n\nion-searchbar {\n  height: 34px;\n  padding-inline-end: 12px;\n  padding-inline-start: 12px;\n  --placeholder-color: var(--ion-color-secondary);\n  --placeholder-opacity: 1;\n  --color: var(--ion-color-secondary);\n  --icon-color: var(--ion-color-secondary);\n  --border-radius: 0px;\n  border-radius: 10px;\n  font-size: 14px;\n  font-family: AppFont, sans-serif;\n\n  @include desktop {\n    width: auto;\n  }\n}\n\n.main-row {\n  height: 100%;\n  overflow: hidden;\n  @include mobile {\n    padding-top: 25px;\n\n  }\n  &.hidden {\n    visibility: hidden;\n    min-height: 0px;\n    height: 0px;\n    transition: ease-out 1s;\n  }\n}\n\napp-order-content {\n  display: block;\n  height: 100%;\n}\n\n.order-col {\n  min-width: 380px;\n}\n\n.padding-end {\n  padding-right: 11px;\n}\nion-footer {\n  background-color: var(--ion-color-tertiary);\n  border-radius: 50px;\n  text-transform: uppercase;\n  display: flex;\n}\n.search-block {\n}\n.footer-btn {\n  width: 100%;\n  @include desktop {\n    display: none;\n  }\n  app-to-order-button {\n    width: 100%;\n  }\n}\n\n.hidden {\n  opacity: 0;\n  display: none !important;\n  transition: 1s linear !important;\n}\n\n.chip {\n  background: transparent;\n  transition: 200ms linear;\n  min-width: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  @include desktop {\n    display: none !important;\n  }\n  .chip-icon {\n    margin: 0;\n    height: 16px;\n  }\n}\n.chip-scroll {\n  background: transparent;\n  transition: 200ms linear;\n  min-width: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  &.rotate {\n    transform: rotate(180deg) !important;\n  }\n  .chip-icon {\n    transform: rotate(180deg);\n    margin: 0;\n    height: 36px;\n  }\n}\n\n.category-info {\n  max-height: 70px;\n  @include desktop {\n    max-height: 80px;\n    ion-img {\n      height: 80px;\n    }\n  }\n  ion-img {\n    height: 70px;\n    width: 100%;\n    object-fit: cover;\n  }\n}\n.background-image {\n  width: 100%;\n  height: 30px;\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  background: url(\"../../../assets/tabilo/test.svg\") center top/100% no-repeat !important;\n  @include desktop {\n    height: 45px;\n    background: url(\"../../../assets/tabilo/test_desktop.svg\") center top/103% no-repeat !important;\n  }\n  z-index: 99;\n}\nion-content {\n  --offset-top: 4px !important;\n  @include desktop {\n    --offset-top: 23px !important;\n  }\n}\n.category-block {\n  max-height: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0px 10px;\n  width: fit-content;\n  position: relative;\n  transition: all 1.2s;\n  cursor: pointer;\n  // background: url('../../../assets/tabilo/background-category.svg')  no-repeat center center / 100% 100%;\n  h4 {\n    font-size: 14px;\n    text-wrap: nowrap;\n    z-index: 999999;\n    color: white;\n    padding: 0px 10px;\n    width: max-content;\n\n  }\n  ion-img {\n    position: absolute;\n    left: 0;\n    right: 0;\n    object-fit: fill;\n    height: 40px;\n    z-index: 1;\n  }\n}\n\n.category-wrapper {\n  background: url('../../../assets/tabilo/category-background.png') no-repeat  center center /110% 138%;\n  background-size: cover;\n  transition: all 0.5s;\n  background-size:1100px;\n  @include desktop {\n    background-size: 4000px;\n  }\n  &.vegan_selected {\n    transition: all 0.5s;\n    background:#06331B url('../../../assets/tabilo/category-background.png') no-repeat  center center /110% 168% ;\n    background-size: cover;\n    background-size:1100px;\n    @include desktop {\n      background-size: 4000px;\n    }\n\n\n    @include desktop {\n      background: #06331B ; \n    }\n  }\n}\n.wrapper-filters {\n  min-height: 70px;\n  width: 100%;\n  transition: all 0.3s;\n  &.hidden {\n    visibility: hidden;\n    opacity: 0;\n    width: 0px;\n\n    transition: all 0.2s;\n  }\n  &.vegan_green {\n    transition: all 0.3s;\n\n    background: #06331B ;\n  }\n  ion-row {\n    height: 100%;\n    .header_block_item {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      position: relative;\n      ion-icon {\n        width: 23px;\n        margin-right: 5px;\n        fill: white;\n      }\n      h3 {\n        font-size: 18px;\n        color: white;\n        font-family: AppFont ,sans-serif;\n        \n      }\n    }\n    .header_block_item::after {\n      position: absolute;\n      right: 0px;\n      content:  ' ';\n      width: 2px;\n      height: 30px;\n      background: white;\n    }\n    .vegan_toggle {\n      display: flex;\n      justify-content: center;\n    }\n  }\n\n}\n.toggler {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background: white;\n  border: 2px solid var(--ion-color-primary);\n  box-shadow: inset -2px 2px 10px rgba(0, 0, 0, 0.25);\n  padding: 7px;\n  border-radius: 50px;\n  width: 100px;\n\n  position: relative;\n\n  &.vegeterian {\n    background: white;\n    border: 2px solid #34A853;\n\n  }\n\n  .toggler_item {\n    padding: 0 7px;\n    font-family: AppFontBold;\n    font-size: 12px;\n    line-height: 19px;\n    color: #06331B;\n    height: 20px;\n    transition: all 0.4s;\n\n    &.selected {\n      opacity: 0;\n      width: 44%;\n      overflow: hidden;\n    }\n  }\n\n  .toggler_pin {\n    position: absolute;\n    color: red;\n    top: -14px;\n    cursor: pointer;\n    transition: all 0.3s ease-out;\n\n    .pin_img {\n      height: 65px;\n      width: 65px;\n    }\n\n    &.first {\n      left: -13px;\n    }\n\n    &.second {\n      left: 61px;\n      @include mobile {\n        left: 44px;\n      }\n    }\n  }\n}\n.row-filters {\n  visibility: visible;\n  opacity: 1;\n  transition: all 0.5s;\n\n  &.hidden {\n    visibility: hidden;\n    opacity: 0;\n    transition: all 0.5s;\n\n  }\n}\n.search-row {\n  visibility: hidden;\n  opacity: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.5s;\n  &.visible {\n    visibility: visible;\n    opacity: 1;\n    transition: all 0.5s;\n\n  }\n}\n.filters-dialog {\n  background: var(--ion-color-secondary);\n  z-index: 0;\n\n  visibility: hidden;\n  opacity: 0;\n  min-height: 0px;\n  height: 0px;\n  transition: ease-in-out 0.5s;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  // justify-content: center;\n  width: 0;\n  overflow: hidden !important;\n  text-align: center;\n  .filters-button {\n    position: fixed;\n    bottom: 20px;\n    width: 48.4% !important;\n    left: 50%;\n    transform: translateX(-50%);\n    @include mobile {\n      width: 86% !important;\n\n    }\n    @media (max-width: 380px) {\n      bottom: 6px;\n    }\n    ion-button {\n      width: 100%;\n      @include desktop {\n        --background: url(../../../assets/tabilo/button_background_orange.png) no-repeat center center/ 100% 100%;\n    \n      }\n    }\n  }\n  &__header {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    h3 {\n      color: white;\n    }\n  }\n  &__border-line {\n    width: 100%;\n    margin: 10px 0px;\n    fill: white;\n  }\n  &__content {\n    width: 100%;\n    visibility: hidden;\n    p {\n      color: white;\n      font-family: Tusker, sans-serif;\n    }\n    &.visible_content {\n      visibility:visible;\n      transition: ease-out 0.5s;\n    }\n  }\n  &.visible {\n    padding: 20px;\n    width: 100%;\n    min-height: 100%;\n    height: 100%;\n    opacity: 1;\n    z-index: 999;\n    visibility: visible;\n    transition: all 0.5s;\n    overflow: auto;\n\n  }\n  ul {\n    list-style-type: none;\n    padding: 0px;\n    width: 0px;\n    visibility: hidden;\n    height: 0px;\n    opacity: 0;\n    &.visible_content {\n      opacity: 1;\n      width: 100%;\n      height: 100%;\n      visibility: visible;\n      transition: all 0.7s;\n\n\n    }li {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 5px 0px;\n      text-decoration: none;\n      transition: all 1s;\n      .wrapper {\n          padding: 20px 20px;\n          background: white;\n          width: 100%;\n          border-radius: 20px;\n          display: flex;\n          align-items: center;\n          justify-content: flex-start;\n          .info_block {\n              border-radius: 20px;\n              display: flex;\n              align-items: center;\n              p {\n                  padding: 0px 10px;\n                  color: var(--ion-color-primary);\n                  font-family: Tusker, sans-serif;\n              }\n          }\n          .circle {\n              width: 0px;\n              height: 20px;\n              content: ' ';\n              border: 2px solid var(--ion-color-primary);\n              border-radius: 5px;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              margin-bottom: 5px;\n              visibility: hidden;\n              opacity: 0;\n              &.selected {\n                visibility: visible;\n                opacity: 1;\n                width: 20px;\n              }  \n              transition: ease-out 0.3s;\n\n          }\n          .cirle_inner {\n            width: 0px;\n            height: 20px;\n            content: ' ';\n            background: transparent;\n            border-radius: 5px;\n            margin-bottom: 5px;\n            position: relative;\n\n            &.selected {\n              width: 20px;\n                background: var(--ion-color-tertiary);\n                border-radius: 50;\n                transition: ease-in-out 0.3s;\n            }\n            ion-icon {\n              position: absolute;\n              top: 50%;\n              left: 50%;\n              width: 0px;\n              transform: translate(-50%, -50%);\n              color: white;\n              &.selected {\n                width: 20px;\n              }\n            }\n        }\n      }\n  }\n}\n\n}\n.order-button  {\n  background: transparent !important;\n  @include desktop {\n    display: none;\n  }\n}\n.hidden_item {\n  visibility: hidden;\n  opacity: 0;\n  width: 0;\n  display: none;\n  &.visible {\n    width: 100%;\n    visibility: visible;\n    opacity: 1;\n\n  }\n}\n.no-data {\n  height: 70vh;\n  position: relative;\n  width: 100%;\n  h3 {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%,-50%);\n    font-family: Tusker, sans-serif;\n  }\n}\n.big-screen {\n  display:none;\n  @include desktop {\n    display: block;\n    &.wrapper-filters {\n\n      padding-top: 10px;\n        height: 100%;\n        .separator {\n          width: 1.5px;\n          height: 30px;\n          background: var(--ion-color-primary);\n        }\n        .header_block_item {\n          position: relative;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          width: 100%;\n          position: relative;\n          &.vegan_color {\n            ion-icon {\n              fill: white !important;\n              color: white !important;\n            }\n            h3 {\n              color: white !important;\n            }\n          }\n          ion-icon {\n            width: 23px;\n            margin-right: 5px;\n            fill: var(--ion-color-primary) !important;\n            color: var(--ion-color-primary) !important;\n            \n          }\n          h3 {\n            font-size: 18px;\n            color: var(--ion-color-primary) !important;\n            font-family: AppFont ,sans-serif;\n          \n          }\n        }\n       \n        .search-row {\n          height: 0px;\n          max-height: 0px;\n          padding-top: 10px;\n        }\n\n    \n    }\n  }\n}\n.small-screen {\n  display: none; \n  @include mobile {\n    display: block;\n  }\n}\n.category-header {\n  font-family: Tusker;\n  font-size: 24px;\n  text-align: left;\n  position: relative;\n  background: url('../../../assets/tabilo/button_background_primary.png') no-repeat center center / 100% 100%;\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  margin: 10px;\n  h3 {\n    z-index: 99;\n    padding: 10px ;\n    color: white;\n  }\n}\n.dialog_auto {\n  overflow: auto;\n  max-height: fit-content;\n  min-height: 88%;\n\n  @media (max-width: 400px) {\n    padding-bottom: 60px;\n    min-height: 85%;\n\n    max-height: 50%;\n  }\n  @include desktop {\n    display: flex;\n    justify-content: center;\n    .dialog_item {\n      width: 50%;\n    }\n  }\n\n}\n\n.reset {\n\n  background-size: 97% 97%;\n  padding: 4px 13px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  border-radius: 6px;\n\n  ion-icon {\n    margin-right: 10px;\n    height: 10px;\n    width: 35px;\n    height: 35px;\n  }\n  ion-img {\n    margin-right: 5px;\n    height: 10px;\n    width: 14px;\n    height: 14px;\n  }\n  p {\n    color: var(--ion-color-black);\n    font-family: AppFontBold;\n    text-transform: capitalize;\n  }\n}\n\n.list-articles {\n  width: 100%;\n  height: 100%;\n  transition: 1s linear;\n  opacity: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  scroll-behavior: smooth;\n  -ms-overflow-style: none;\n  scrollbar-width: none; /* Firefox */\n\n  align-items: center;\n  justify-content: flex-start;\n}\n.items-wrap {\n  width: 100%;\n}\n.content-articles {\n  position: relative;\n  width: 100%;\n  height: 100%;\n \n}\n.info_dialog_error {\n\n  background: var(--ion-color-primary);\n\n  padding: 8px 17px;\n  text-align: center;\n  width: max-content;\n\n  animation: appears 0.3s forwards;\n  height: fit-content;\n  margin: 0 auto 30px;\n  max-width: 80%;\n  p {\n    height: fit-content;\n    max-height: max-content;\n    color: white;\n  }\n  @keyframes appears {\n    from {\n      opacity: 0\n    }\n    to {\n      opacity: 1;\n    }\n  }\n}\n.wrapper-errors {\n  position: relative;\n  width: 100%;\n  height: fit-content;\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
